import React from "react";
import visionImg from "../assets/aboutpagemain.png"; // Use your uploaded image filename
import stat1 from "../assets/support.png";
import stat2 from "../assets/Logomain.jpg";
import stat3 from "../assets/support1.png";
import Footer from "./Footer.js";
import ContactForm from "./ContactForm.js";
function AboutPage() {
  return (
    <>
      <div>
        {/* Vision Section */}
        <section className="about-vision-section">
          <div className="about-vision-img">
            <img src={visionImg} alt="Our Vision" />
          </div>
          <div className="about-vision-text">
            <div className="about-intro">Our Vision</div>
            <h2>
              Adding colours to the life by <br />
              providing different opportunities to grow and achieve their goals.
            </h2>
          </div>
        </section>

        {/* Quote & Mission Section */}
        <section className="about-quote-section">
          <div className="about-intro">About Us</div>
          <h2 className="about-quote">
            “It is not our disabilities It is our abilities that count!” -Chris
            Burke
          </h2>
          <div className="about-paragraphs">
            <p>
              Our dedicated team work with clients and their families by
              listening to their needs and requirements and tailoring a package
              that best suits their needs promoting independence and giving
              choices and control in their life.
            </p>
            <p>
              We wish to serve and care for our local community which is
              vulnerable and in need. We have the knowledge to comprehend
              physical requirements, effectively communicate with medical
              personnel, and provide accurate, comprehensive follow-up
              information.
            </p>
            <p>
              We hire only the most qualified individuals to keep our clients
              safe and provide flawless service. Our staff has passion and
              compassion towards care. We assist our clients in maintaining
              their freedom on their own terms.
            </p>
          </div>
        </section>

        {/* Stats Section */}
        <section className="about-stats-section">
          <div className="about-stat">
            <img src={stat1} alt="Support Services" />
            <div className="about-stat-number">12+</div>
            <div className="about-stat-label">Support Services</div>
          </div>
          <div className="about-stat">
            <img src={stat2} alt="Support Workers" />
            <div className="about-stat-number">50+</div>
            <div className="about-stat-label">Support Workers</div>
          </div>
          <div className="about-stat">
            <img src={stat3} alt="Happy Citizens" />
            <div className="about-stat-number">200+</div>
            <div className="about-stat-label">Happy Citizens</div>
          </div>
        </section>
      </div>
      <ContactForm />
      <Footer />
    </>
  );
}

export default AboutPage;
